import Entity from "../Entity";

export default class ShowcaseShop extends Entity {}
ShowcaseShop.addProperties({
	showcaseId: Number,
	shopId: Number,
	activated: Boolean,
	creationDate: Number,
});
